import * as types from "../../types";

export default function (state = [], action) {
    const { type, payload } = action;

    switch (type) {
        case types.GET_USER_TOTALS:
            return {
                ...state,
                totals: payload
            };
        default:
            return state;
    }
}